import { render, staticRenderFns } from "./TradeLicenseDetails.vue?vue&type=template&id=523e6440"
import script from "./TradeLicenseDetails.vue?vue&type=script&lang=js"
export * from "./TradeLicenseDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports